import { displayMonth } from "./displayMonth";

export function friendlydate(n,show_time=true) {
 return `${displayMonth(n?.getMonth()+1)} ${n?.getDate()}, ${n?.getFullYear()}${show_time ? ` ${n?.toLocaleTimeString()}` : ''}`
}